/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as WelcomeRouteRouteImport } from './routes/welcome/route'
import { Route as HomeRouteRouteImport } from './routes/_home/route'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as HomeIndexRouteImport } from './routes/_home/index'
import { Route as WelcomePartnerIdRouteImport } from './routes/welcome/$partnerId'

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRouteRoute = WelcomeRouteRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRouteRoute = HomeRouteRouteImport.update({
  id: '/_home',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HomeRouteRoute,
} as any)
const WelcomePartnerIdRoute = WelcomePartnerIdRouteImport.update({
  id: '/$partnerId',
  path: '/$partnerId',
  getParentRoute: () => WelcomeRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof HomeIndexRoute
  '/welcome': typeof WelcomeRouteRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/welcome/$partnerId': typeof WelcomePartnerIdRoute
  '/auth/': typeof AuthIndexRoute
}
export interface FileRoutesByTo {
  '/welcome': typeof WelcomeRouteRouteWithChildren
  '/welcome/$partnerId': typeof WelcomePartnerIdRoute
  '/': typeof HomeIndexRoute
  '/auth': typeof AuthIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_home': typeof HomeRouteRouteWithChildren
  '/welcome': typeof WelcomeRouteRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/welcome/$partnerId': typeof WelcomePartnerIdRoute
  '/_home/': typeof HomeIndexRoute
  '/auth/': typeof AuthIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/welcome' | '/auth' | '/welcome/$partnerId' | '/auth/'
  fileRoutesByTo: FileRoutesByTo
  to: '/welcome' | '/welcome/$partnerId' | '/' | '/auth'
  id:
    | '__root__'
    | '/_home'
    | '/welcome'
    | '/auth'
    | '/welcome/$partnerId'
    | '/_home/'
    | '/auth/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  HomeRouteRoute: typeof HomeRouteRouteWithChildren
  WelcomeRouteRoute: typeof WelcomeRouteRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_home': {
      id: '/_home'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof HomeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_home/': {
      id: '/_home/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof HomeRouteRoute
    }
    '/welcome/$partnerId': {
      id: '/welcome/$partnerId'
      path: '/$partnerId'
      fullPath: '/welcome/$partnerId'
      preLoaderRoute: typeof WelcomePartnerIdRouteImport
      parentRoute: typeof WelcomeRouteRoute
    }
  }
}

interface HomeRouteRouteChildren {
  HomeIndexRoute: typeof HomeIndexRoute
}

const HomeRouteRouteChildren: HomeRouteRouteChildren = {
  HomeIndexRoute: HomeIndexRoute,
}

const HomeRouteRouteWithChildren = HomeRouteRoute._addFileChildren(
  HomeRouteRouteChildren,
)

interface WelcomeRouteRouteChildren {
  WelcomePartnerIdRoute: typeof WelcomePartnerIdRoute
}

const WelcomeRouteRouteChildren: WelcomeRouteRouteChildren = {
  WelcomePartnerIdRoute: WelcomePartnerIdRoute,
}

const WelcomeRouteRouteWithChildren = WelcomeRouteRoute._addFileChildren(
  WelcomeRouteRouteChildren,
)

interface AuthRouteChildren {
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  HomeRouteRoute: HomeRouteRouteWithChildren,
  WelcomeRouteRoute: WelcomeRouteRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
